export enum PriceSheetType {
  SystemDefault = 'SYSTEM_DEFAULT',
  PreferredGenerated = 'PREFERRED_GENERATED',
  SystemManual = 'SYSTEM_MANUAL',
}
